import { render, staticRenderFns } from "./ProductOptionsPage.vue?vue&type=template&id=2ca4d98e&"
import script from "./ProductOptionsPage.vue?vue&type=script&lang=js&"
export * from "./ProductOptionsPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductOptionsPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports